/**
 * The position-sizing endpoint behind a quantity edit (MDOT-25670), and the only place in the tree
 * that calls `sizePosition` or `sizePositionOfNewPortfolio` — deleting `position-sizing/` takes the
 * call sites with it.
 */
import { getApiGen } from "$root/api/factory";
import { repositoryHelperFactory } from "$root/api/repository";
import { axiosExtract } from "$root/third-party-integrations/axios";
import {
	InvestmentSharesControllerV4ApiFactory,
	type PositionSizingRequest,
	type PositionSizingResponse,
} from "@eu.mdotm.api/sphere";

const { newAction } = repositoryHelperFactory("positionSizing");

const sharesApi = () => getApiGen(InvestmentSharesControllerV4ApiFactory);

export const positionSizingRepository = {
	/**
	 * Sizes one instrument of the portfolio on Cold War from the one value the user typed. Synchronous
	 * server-side; the numbers come back as Cold War computed them. Aborting `signal` cancels the request.
	 * Without a portfolio — a composition being created — the request's own amount and currency are all
	 * there is to size against.
	 */
	deriveInstrumentValue: newAction(
		(
			investmentUuid: string | undefined,
			request: PositionSizingRequest,
			signal?: AbortSignal,
		): Promise<PositionSizingResponse> =>
			axiosExtract(
				investmentUuid == null
					? sharesApi().sizePositionOfNewPortfolio(request, { signal })
					: sharesApi().sizePosition(investmentUuid, request, { signal }),
			),
	),
} as const;
